import { render, staticRenderFns } from "./index.vue?vue&type=template&id=d5196d82&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./styles/chart.less?vue&type=style&index=0&id=d5196d82&prod&lang=less&scoped=true&external"
import style1 from "./styles/widgets.less?vue&type=style&index=1&prod&lang=less&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5196d82",
  null
  
)

export default component.exports